export const getShopBottles = _state => {
  return _state.bottles
}

export const getShopMasterclasses = _state => {
  return _state.masterclasses
}

export const getCheckout = _state => {
  return _state.checkout
}
